import { FC } from 'react';
import styles from './loader.module.scss';

const Loader: FC<{ width?: string }> = ({ width }: { width?: string }) => {
    return (
        <div className={styles['loader-wrapper']} style={{ width }}>
            <div className={styles.loader} />
        </div>
    );
};

export default Loader;
